import { css } from 'linaria';

export const title = css`
  && {
    margin-bottom: 40px;

    @media (--only-mobile) {
      margin-bottom: 24px;
    }
  }
`;

export const advantagesList = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 0;
  margin: 0;
  column-gap: 24px;
  row-gap: 40px;
  list-style: none;

  @media (--only-tablet) {
    column-gap: 16px;
    row-gap: 24px;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    column-gap: 0;
    row-gap: 24px;
  }
`;

export const advantageIcon = css`
  display: block;
  margin-bottom: 16px;
`;

export const advantageName = css`
  display: block;
  margin-bottom: 8px;
`;
